import {adminHttp} from "~/Admin/services/http";

export const loadGuest = (guest) => async (dispatch) => {
    dispatch({
        type: "LOAD_GUEST",
        payload: guest || {}
    });
};

export const loadDietaries = () => async (dispatch) => {

    const response = await adminHttp.get('/dietaries?page=1');

    dispatch({
        type: "LOAD_DIETARIES",
        payload: response?.data?.data || []
    });
};
